import React, { useEffect, useRef, useState } from "react";
import suspension from "../../../../../assets/image/category/suspension.webp";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import clunking from "../../../../../assets/image/services/clunking.webp";
import roadnoise from "../../../../../assets/image/services/roadnoise.webp";
import suspensionsteering from "../../../../../assets/image/services/suspensionsteering.webp";
import suspension4 from "../../../../../assets/image/services/suspension4.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import MyButton from "../../utils/Button/MyButton";

export default function Suspension_Steering() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <div className="overflow-hidden">
      {/* Suspension Steering Services*/}
      {/* 
      <h1 className="text-black-900 font-bold lg:text-4xl md:text-3xl text-xl px-3 text-center pb-2" style={{ textAlign: "left" }}>
        Experiencing a Rough Ride? Here’s What’s Happening.         </h1> */}
      <div className="text-black ">
        {/* Image Column (5/12) */}
        <div className="lg:col-span-5 md:col-span-1 relative flex items-center">
          <img
            className=" w-full h-[20rem] object-cover lg:h-[30rem] "
            src={suspension}
            alt="suspension"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/70 to-transparent"></div>
          <div className="absolute inset-0 lg:mb-20 mb-16 flex items-center justify-center text-white text-center">
            <h3
              className={`text-white text-center font-bold absolute lg:text-[3.6rem] md:text-3xl text-2xl
           transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
            >
              Expert Suspension & Steering Services
            </h3>
          </div>
          <div
            className={`w-full flex items-center lg:mt-9 md:mt-8 mt-10 absolute inset-0 justify-center  
            transition-all duration-[900ms] delay-1000 ease-in-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
              <MyButton
                text="  Suspension & Steering Services"
                className="bg-orange-500 text-white  py-[12px] rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12) */}
        <div className=" lg:px-[12%]   lg:py-[35px] md:py-[35px] py-4">
          <div className="container mx-auto  max-w-4xl  text-center">
            <p className="my-3 lg:font-normal  text-gray-700  text-xl">
              If your car feels bumpy, leans to one side, or vibrates
              excessively, your suspension system is likely worn or damaged. The
              suspension absorbs road impact, ensuring stability and control.
              Failing components lead to uneven tire wear, poor handling, and
              potential safety .
            </p>

            <p className="mb-3 lg:font-normal  text-gray-700 lg:block md:block hidden text-xl">
              Our certified mechanics at Vancouver Auto Parts ensure your
              suspension and steering systems are in top shape—so you can enjoy
              a smooth, safe ride.
            </p>

            {/* <ul className="ps-1">
              {[
                'Excessive bouncing or swaying',
                'Uneven tire wear',
                'Loose or stiff steering',
                'Clunking noises over bumps',
                'Car pulling to one side',
                'Steering wheel vibration',
              ].map((item, index) => (
                <li key={index} className="hover:text-blue-900 flex items-center mb-1 text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className="text-white p-0.5" />
                  </span>
                  {item}
                </li>
              ))}
            </ul> */}

            <div
              className={`
           transition-all duration-[950ms] delay-[2500ms] ease-in-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-white bg-orange-500 cursor-pointer flex items-center">
                  Book a FREE Inspection <FaArrowRight className="ml-2" />
                </button> */}

                <MyButton
                  text="Book a FREE Inspection  "
                  className="mx-auto transform transition-transform duration-500 hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]">
        <div className="py-[30px]  container  ">
          <h1 className="text-blue-900 font-bold  lg:px-[7%] text-[1.8rem] md:text-[2.6rem] lg:text-[2.9rem] text-center mb-3">
            Expert Repairs for Long-Term Performance
          </h1>
          <p className="mb-3 lg:font-normal lg:block md:block hidden text-center text-[1.35rem] lg:mt-5 lg:px-[9%]">
            When suspension or steering components wear out, your car becomes
            harder to control, increasing the risk of skidding, uneven tire
            wear, and unpredictable steering response. Our expert team diagnoses
            issues with precision and delivers lasting repairs, ensuring your
            vehicle remains stable, and safe on every drive.
          </p>
          <p className="mb-3 lg:font-normal text-center   lg:px-[9%] text-[1.35rem]">
            As a trusted online auto parts provider and distributor, we stock
            only high-quality automotive parts that meet or exceed industry
            standards—giving you reliable, long-term solutions.
          </p>

          <div className="flex justtify-center items-center lg:px-[5%] py-3  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={clunking}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Check Your{" "}
                      <span className="text-[#2772AD]">Suspension </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    Worn suspension parts like shocks, struts, and bushings
                    weaken your vehicle’s grip and handling. This not only
                    affects ride comfort—it also reduces safety during braking
                    and cornering. A precise suspension check helps restore
                    stability and confidence behind the wheel. Don’t let hidden
                    wear put you at risk.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[5%] justify-between   ">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem]  text-3xl   ">
                    <b>
                      Bushings Control the{" "}
                      <span className="text-[#2772AD]">Drive</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    Worn suspension bushings may seem minor, but they allow
                    excess movement that affacts critical wheel alignment and
                    overall stability. This results in uneven tire wear,
                    unpredictable handling, and a rougher ride. Replacing
                    damaged bushings helps restore precise steering and road
                    control your vehicle safe.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={suspensionsteering}
                    alt=""
                    className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={suspension4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl  ">
                    <b>
                      Grip Lost to{" "}
                      <span className="text-[#2772AD]">Misalignment </span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    A misaligned suspension does more than cause uneven tire
                    wear—it significantly increases braking distance and reduces
                    overall traction. Poor alignment disrupts how your tires
                    connect with the road, especially in sudden stops or sharp
                    turns. Precision suspension tuning restores balance,
                    improves grip, and keeps your vehicle responsive and safe .
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-3 lg:font-normal text-center lg:px-[7%]  text-xl ">
            A shaky, unsteady ride means trouble is brewing. Driving with a
            faulty suspension increases braking distance, reduces tire lifespan,
            and compromises safety. Vancouver Auto Parts provides expert repairs
            with quick turnaround times and high-quality parts.
          </p>
          <div className="w-full flex justify-center mt-2 mb-3 transform transition-transform duration-500 hover:scale-105">
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer flex items-center">
                Get a Free Check <FaArrowRight className="ml-2" />
              </button> */}

              <MyButton text="Get a Free Check" className="py-[11px]" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
